import type {ChipId} from '../game/config';

export type CoopScores = [number,number];
export type CoopLoadouts = [[ChipId,ChipId],[ChipId,ChipId]];
export interface CoopProgress {
  unlocked:number;
  stars:Record<string,number>;
  best:Record<string,number>;
  checkpoints:Record<string,CoopScores>;
  loadouts:CoopLoadouts;
}
export function normalizeCoopProgress(value:any):CoopProgress {
  const integer=(n:unknown,max=1_000_000_000)=>Number.isFinite(n)?Math.max(0,Math.min(max,Math.floor(Number(n)))):0;
  const record=(input:any,max:number)=>input&&typeof input==='object'?Object.fromEntries(Object.entries(input).filter(([key])=>/^\d{1,2}$/.test(key)&&Number(key)>=1&&Number(key)<=50).map(([key,n])=>[key,integer(n,max)])):{};
  const checkpoints:Record<string,CoopScores>={};
  if(value?.checkpoints&&typeof value.checkpoints==='object')for(const [key,scores] of Object.entries(value.checkpoints)){
    if(/^\d{1,2}$/.test(key)&&Number(key)>1&&Number(key)<=50&&Array.isArray(scores)&&scores.length===2)checkpoints[key]=[integer(scores[0]),integer(scores[1])];
  }
  const allowed=new Set(['magnet','blast','twinHook','timeDilation','gravityFlip','goldFever','pocketClock','seedPouch','lantern','mossShield','surveyLens','starElixir','rescueBell','ropeShears']);
  const loadouts:CoopLoadouts=[['magnet','blast'],['twinHook','rescueBell']];
  if(Array.isArray(value?.loadouts))for(let i=0;i<2;i++){
    const pair=value.loadouts[i];
    if(Array.isArray(pair)&&pair.length===2&&pair[0]!==pair[1]&&pair.every(id=>allowed.has(id)))loadouts[i]=pair as [ChipId,ChipId];
  }
  return {unlocked:Math.max(1,integer(value?.unlocked,50)),stars:record(value?.stars,3),best:record(value?.best,1_000_000_000),checkpoints,loadouts};
}
